import { Component } from '@angular/core';
import {TemplatingPreviewComponent} from "../templating-preview/templating-preview.component";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {MatButtonModule} from "@angular/material/button";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {ApiService} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-templating-delete',
  standalone: true,
  imports: [
    TemplatingPreviewComponent,
    ActionsContainerComponent,
    MatButtonModule,
    BackButtonComponent
  ],
  templateUrl: './templating-delete.component.html'
})
export class TemplatingDeleteComponent {

  loading = false
  error: any

  constructor(
    readonly api: ApiService,
    readonly router: Router,
    readonly route: ActivatedRoute) {
  }

  confirmDelete(){
    const templateId = this.route.snapshot.params['templateId']
    this.loading = true
    this.error = null
    this.api.deleteTemplate(templateId).subscribe({
      next: (r) => {
        this.loading = false
        this.router.navigate(['/templates']).finally(() => {})
      },
      error: (err) => {
        this.error = err
        this.loading = false
      }
    })
  }
}
